// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[app-viewport],
[overlay-portal],
[nav-viewport],
[tab-portal],
.nav-decor {
  display: none !important;
  background: none transparent !important;
}

ion-menu {
  --height: 120px;
}

.anchor-simples {
  color: white;
}

.custom-header {
  z-index: 99999999;
  color: white;
  background-color: black;
}

.custom-header-conecta {
  z-index: 99999999;
  color: white;
  background: #2abbda;
}

.header-android {
  height: 50px;
}

.header-ios {
  height: 65px;
}

.tituloPagina {
  font-family: Circular, Helvetica, Arial, sans-serif, IosFix;
  font-weight: bold;
  font-size: 18px;
  position: relative;
  top: 16px;
}

.botao-menu {
  position: relative;
  float: right;
  font-size: 40px;
  top: 5px;
  right: 5px;
}

.pesquisa-global {
  position: relative;
  width: 100%;
  background-color: black;
  padding-bottom: 10px;
  box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;
}

.resultado-busca {
  position: relative;
  top: 15px;
  background-color: white;
  color: black;
  z-index: 888;
  height: 70%;
  overflow: scroll;
}

.chip-pesquisa {
  color: white;
}

.chip-pesquisa-selecionado {
  background-color: #148b7f;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss","webpack://./../../../../../../Luar%20Faria/source/repos/luarfaria/Legislapp/Legislapp.Mobile/src/app/app.component.scss"],"names":[],"mappings":"AAAA;;;;;EAKE,wBAAA;EACA,uCAAA;ACCF;;ADEA;EACE,eAAA;ACCF;;ADEA;EACE,YAAA;ACCF;;ADMA;EACE,iBAAA;EACA,YAAA;EACA,uBAAA;ACHF;;ADMA;EACE,iBAAA;EACA,YAAA;EACA,mBAAA;ACHF;;ADMA;EACE,YAAA;ACHF;;ADMA;EACE,YAAA;ACHF;;ADMA;EACE,2DAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;ACHF;;ADMA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;EACA,UAAA;ACHF;;ADMA;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,oBAAA;EACA,4CAAA;ACHF;;ADMA;EACE,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;ACHF;;ADMA;EACE,YAAA;ACHF;;ADMA;EACE,yBAAA;EACA,YAAA;ACHF","sourcesContent":["[app-viewport],\r\n[overlay-portal],\r\n[nav-viewport],\r\n[tab-portal],\r\n.nav-decor {\r\n  display: none !important;\r\n  background: none transparent !important;\r\n}\r\n\r\nion-menu {\r\n  --height: 120px;\r\n}\r\n\r\n.anchor-simples {\r\n  color: white;\r\n}\r\n\r\n// ion-header {\r\n//   --background-color: black;\r\n// }\r\n\r\n.custom-header {\r\n  z-index: 99999999;\r\n  color: white;\r\n  background-color: black;\r\n}\r\n\r\n.custom-header-conecta {\r\n  z-index: 99999999;\r\n  color: white;\r\n  background: #2abbda;\r\n}\r\n\r\n.header-android {\r\n  height: 50px;\r\n}\r\n\r\n.header-ios {\r\n  height: 65px;\r\n}\r\n\r\n.tituloPagina {\r\n  font-family: Circular, Helvetica, Arial, sans-serif, IosFix;\r\n  font-weight: bold;\r\n  font-size: 18px;\r\n  position: relative;\r\n  top: 16px;\r\n}\r\n\r\n.botao-menu {\r\n  position: relative;\r\n  float: right;\r\n  font-size: 40px;\r\n  top: 5px;\r\n  right: 5px;\r\n}\r\n\r\n.pesquisa-global {\r\n  position: relative;\r\n  width: 100%;\r\n  background-color: black;\r\n  padding-bottom: 10px;\r\n  box-shadow: rgb(0 0 0 / 12%) 0px 4px 16px;\r\n}\r\n\r\n.resultado-busca {\r\n  position: relative;\r\n  top: 15px;\r\n  background-color: white;\r\n  color: black;\r\n  z-index: 888;\r\n  height: 70%;\r\n  overflow: scroll;\r\n}\r\n\r\n.chip-pesquisa {\r\n  color: white;\r\n}\r\n\r\n.chip-pesquisa-selecionado {\r\n  background-color: #148b7f;\r\n  color: white;\r\n}\r\n","[app-viewport],\n[overlay-portal],\n[nav-viewport],\n[tab-portal],\n.nav-decor {\n  display: none !important;\n  background: none transparent !important;\n}\n\nion-menu {\n  --height: 120px;\n}\n\n.anchor-simples {\n  color: white;\n}\n\n.custom-header {\n  z-index: 99999999;\n  color: white;\n  background-color: black;\n}\n\n.custom-header-conecta {\n  z-index: 99999999;\n  color: white;\n  background: #2abbda;\n}\n\n.header-android {\n  height: 50px;\n}\n\n.header-ios {\n  height: 65px;\n}\n\n.tituloPagina {\n  font-family: Circular, Helvetica, Arial, sans-serif, IosFix;\n  font-weight: bold;\n  font-size: 18px;\n  position: relative;\n  top: 16px;\n}\n\n.botao-menu {\n  position: relative;\n  float: right;\n  font-size: 40px;\n  top: 5px;\n  right: 5px;\n}\n\n.pesquisa-global {\n  position: relative;\n  width: 100%;\n  background-color: black;\n  padding-bottom: 10px;\n  box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 16px;\n}\n\n.resultado-busca {\n  position: relative;\n  top: 15px;\n  background-color: white;\n  color: black;\n  z-index: 888;\n  height: 70%;\n  overflow: scroll;\n}\n\n.chip-pesquisa {\n  color: white;\n}\n\n.chip-pesquisa-selecionado {\n  background-color: #148b7f;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
